/**
 * Chapter layout — wraps chapter-scoped routes with a sub-nav.
 *
 * Used by routes under /c/:chapterSlug, except the chapter landing
 * which renders ChapterLandingPage directly under RootLayout.
 */

import { NavLink, Outlet } from 'react-router';
import { useScope } from '@/contexts/ScopeContext';

export function ChapterLayout() {
  const { chapter, loading, error } = useScope();
  if (loading) return <div className="container mx-auto px-4 py-12 text-white/60">Loading…</div>;
  if (error || !chapter) return <div className="container mx-auto px-4 py-12 text-red-400">{error ?? 'Chapter not found'}</div>;

  const base = `/c/${chapter.slug}`;

  return (
    <div className="min-h-screen flex flex-col">
      <div className="container mx-auto px-4 py-3 border-b border-white/10">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <h1 className="text-lg font-semibold text-white">{chapter.displayName}</h1>
          <nav className="flex gap-3 text-sm">
            <Tab to={base} end>Home</Tab>
            <Tab to={`${base}/events`}>Events</Tab>
            <Tab to={`${base}/projects`}>Projects</Tab>
            <Tab to={`${base}/gallery`}>Gallery</Tab>
          </nav>
        </div>
      </div>
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}

function Tab({ to, end, children }: { to: string; end?: boolean; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `px-3 py-1.5 rounded transition-colors ${
          isActive ? 'bg-primary/20 text-white' : 'text-white/70 hover:text-white hover:bg-white/5'
        }`
      }
    >
      {children}
    </NavLink>
  );
}

export default ChapterLayout;
